import { render } from "./Navbar.vue?vue&type=template&id=0f6a1b23&scoped=true&lang=html"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=0f6a1b23&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-0f6a1b23"

export default script